const YEAR_OVER_YEAR_GROWTH_HEADING = "YoY";
const QUARTER_OVER_QUARTER_GROWTH_HEADING = "QoQ"
const HALF_YEAR_OVER_HALF_YEAR_GROWTH_HEADING = "HoH"

export { YEAR_OVER_YEAR_GROWTH_HEADING, HALF_YEAR_OVER_HALF_YEAR_GROWTH_HEADING, QUARTER_OVER_QUARTER_GROWTH_HEADING }